import React from 'react';
import { Card, CardProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { FullSizeProgress } from '../../../routing/RouteSuspense';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    zIndex: 2,
    borderRadius: '4px',
    // boxShadow: '0px 5px 18px rgba(108, 108, 108, 0.15);',
    padding: '40px',
    [theme.breakpoints.down('md')]: {
      padding: '25px 30px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 15px',
    },
  },
  offCard: {
    padding: 0,
    boxShadow: 'unset',
    borderRadius: 0,
  },
  error: {
    border: `1px solid ${theme.palette.secondary.main}`,
  },
}));

type PBaseCard = CardProps & {
  offCardStyles?: boolean;
  loading?: boolean;
  error?: boolean;
};

export const BaseCard: React.FC<PBaseCard> = (props) => {
  const {
    children,
    className,
    loading = false,
    offCardStyles = false,
    error,
    ...otherProps
  } = props;
  const classes = useStyles(props);
  return (
    <Card
      className={clsx(
        offCardStyles ? classes.offCard : classes.root,
        error && classes.error,
        className,
      )}
      {...otherProps}
    >
      {loading ? <FullSizeProgress /> : children}
    </Card>
  );
};
